import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import Card from 'react-bootstrap/Card';
import { useState } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import {Link, useNavigate} from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Footer from './Common_Components/Footer';


const OldLifeJapan = () => {
  const [activePage, setActivePage] = useState("Learning");
  const navigate = useNavigate();
  return (
    <div className='OldJapanLife_Container d-flex flex-column' style={{minHeight:"100vh"}} >
    <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate('/LifeInJapan')} className='icon_1' />

                            <h2>Old Life Japan</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>


                    </div>
                </div>
            </div>
  <div className="OldLifeJapan_Main" style={{marginTop:"100px"}}>
  
    <div className="container">
        <div className="row">
            <div className="col-md-3">
            <Link to={"/LifeOldJapanDay1"} style={{ textDecoration: 'none', color: 'inherit' }} >
            <Card style={{ width: '100%' }} className=' lifeInJapan_card' >
          <Card.Img variant="top" src={`${process.env.PUBLIC_URL}/assets/images/Profile.jpg`} />
          <Card.Body>
            <Card.Title>Day 1</Card.Title> 
          </Card.Body>
        </Card>
        </Link>
            </div>
        </div>
    </div>
  </div>
        <Footer /> 
 
    </div>
  )
}

export default OldLifeJapan